/**
 * Prop 65 modal — must load as an external file. Inline <script> inside
 * wetheme-product-form (inline-template) is compiled by Vue and leaks as text.
 */
(function () {
  if (window.__clnfProp65WarningAsset) return;
  window.__clnfProp65WarningAsset = true;

  function initModernOverlays() {
    document.querySelectorAll('.prop-65-warning__overlay[id^="prop-65-overlay-"]').forEach(function (overlay) {
      if (overlay.getAttribute('data-clnf-prop65-bound') === '1') return;
      overlay.setAttribute('data-clnf-prop65-bound', '1');

      var key = overlay.id.replace(/^prop-65-overlay-/, '');
      var trigger = document.getElementById('prop-65-trigger-' + key);
      if (!trigger) return;

      var closeBtn = document.getElementById('prop-65-close-' + key);
      var printBtn = document.getElementById('prop-65-print-' + key);
      var dialog = overlay.querySelector('.prop-65-warning__dialog');

      function openModal() {
        if (overlay.parentNode !== document.body) {
          document.body.appendChild(overlay);
        }
        overlay.hidden = false;
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.hidden = true;
        document.body.style.overflow = '';
      }

      function printMessage() {
        if (!dialog) return;
        var w = window.open('', '_blank');
        if (!w) return;
        var doc =
          '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Prop 65 Warning</title><style>body{font-family:system-ui,sans-serif;padding:1.25rem;line-height:1.5}</style></head><body>' +
          dialog.innerHTML +
          '</body></html>';
        w.document.write(doc);
        w.document.close();
        w.focus();
        w.print();
        w.close();
        closeModal();
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (printBtn) printBtn.addEventListener('click', printMessage);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
    });
  }

  function initLegacySection() {
    var overlay = document.getElementById('prop-65-modal-overlay');
    if (!overlay || overlay.getAttribute('data-clnf-prop65-legacy-bound') === '1') return;
    overlay.setAttribute('data-clnf-prop65-legacy-bound', '1');

    window.openProp65Modal = function () {
      if (overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
      }
      overlay.classList.add('show');
      document.body.style.overflow = 'hidden';
    };

    window.closeProp65Modal = function (event) {
      if (event && event.target !== event.currentTarget) return;
      overlay.classList.remove('show');
      document.body.style.overflow = '';
    };

    window.printProp65Message = function () {
      var modal = document.querySelector('.prop-65-modal');
      if (!modal) return;
      var modalContent = modal.innerHTML;
      var printWindow = window.open('', '_blank');
      if (!printWindow) return;
      var html =
        '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Prop 65 Warning</title><style>body{font-family:Arial,sans-serif;padding:20px}</style></head><body>' +
        modalContent +
        '</body></html>';
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    };
  }

  function onEscape(e) {
    if (e.key !== 'Escape') return;

    document.querySelectorAll('.prop-65-warning__overlay.is-open').forEach(function (overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.hidden = true;
    });
    document.body.style.overflow = '';

    var leg = document.getElementById('prop-65-modal-overlay');
    if (leg && leg.classList.contains('show')) {
      leg.classList.remove('show');
      document.body.style.overflow = '';
    }
  }

  function run() {
    initModernOverlays();
    initLegacySection();
  }

  document.addEventListener('keydown', onEscape);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
